/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
export const snakeToCamelCase = (str: string) =>
  str.replace(/([_][a-zA-Z0-9])/g, group =>
    group.toUpperCase().replace('_', '')
  );

export const camelToSnakeCase = (str: string) =>
  str.replace(/([A-Z])/g, group => '_' + group.toLowerCase());

export const transformObjectCase = (
  obj: any,
  method: 'snake_to_camel' | 'camel_to_snake'
): any => {
  if (!obj || typeof obj !== 'object') {
    return obj; // if it was primitive, null or undefined, just return it as it was
  }

  if (Array.isArray(obj)) {
    return obj.map(value => transformObjectCase(value, method));
  }

  return Object.entries(obj).reduce((acc, [fromCaseKey, val]) => {
    const toCaseKey =
      method === 'snake_to_camel'
        ? snakeToCamelCase(fromCaseKey)
        : camelToSnakeCase(fromCaseKey);
    const value = transformObjectCase(val, method);

    acc[toCaseKey] = value;
    return acc;
  }, {} as any);
};
